export const isCpf = (c) => {
  if ((c = c.replace(/[^\d]/g, '')).length !== 11) return false;
  if (c === '00000000000') return false;
  let r;
  let s = 0;
  for (let i = 1; i <= 9; i++) s = s + parseInt(c[i - 1]) * (11 - i);
  r = (s * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(c[9])) return false;
  s = 0;
  for (let i = 1; i <= 10; i++) s = s + parseInt(c[i - 1]) * (12 - i);
  r = (s * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(c[10])) return false;
  return true;
};

export const isEmail = (email) => {
  let re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const isFullName = (name) => {
  const snps = name?.split(' ');
  return snps?.length > 1 && snps[0].length > 2 && snps[1].length > 2;
};

export const isPassword = (password) => {
  return (
    password?.match(/[-./',;&@#*)(_+:"´`~]/) &&
    password?.length > 5 &&
    password?.match(/[0-9]/) &&
    password?.match(/[A-Z]/)
  );
};

export const isOmni = (bank) => {
  const cnpjOmni = '60850229000147';
  const cnpjFornecido = bank?.cnpj || bank?.banco?.cnpj;
  if (!cnpjFornecido) return false;
  const cnpjLimpo = String(cnpjFornecido).replace(/\D/g, '');
  return cnpjLimpo === cnpjOmni;
};

export const formatadores = {
  // Converte ISO Completo usando Date (AAAA-MM-DDThh:mm:ss.mmsZ) para Brasileiro (DD/MM/AAAA)
  TIMESTAMP_TO_BR: (str) => {
    if (!str) {
      return '';
    }
    const date = new Date(str);
    if (isNaN(date.getTime())) {
      return '';
    }
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  },
  // Converte ISO (AAAA-MM-DD) para Brasileiro (DD/MM/AAAA)
  ISO_TO_BR: (str) => {
    if (!str) {
      return '';
    }
    return str.split('-').reverse().join('/');
  },
  // Converte Americano (MM/DD/AAAA) para ISO (AAAA-MM-DD)
  US_TO_ISO: (str) => {
    if (!str) {
      return '';
    }
    const [mes, dia, ano] = str.split('/');
    return `${ano}-${mes}-${dia}`;
  },
  // Converte Americano (MM/DD/AAAA) para Brasileiro (DD/MM/AAAA)
  US_TO_BR: (str) => {
    if (!str) return '';
    const [mes, dia, ano] = str.split('/');
    return `${dia}/${mes}/${ano}`;
  },
  // Adiciona X dias à data atual e retorna em formato ISO (AAAA-MM-DD)
  ADD_DAYS_ISO: (days) => {
    const data = new Date();
    data.setDate(data.getDate() + parseInt(days || 0));
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  },
  // Retorna a data de hoje no formato Brasileiro (DD/MM/AAAA)
  TODAY_BR: () => new Date().toLocaleDateString('pt-BR'),
  // Retorna a data de hoje no formato ISO (AAAA-MM-DD)
  TODAY_ISO: () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  },
  // Retorna a diferença em dias entre a data atual e a data fornecida.
  DIFF_DAYS_NOW: (dateStr) => {
    if (!dateStr) return 0;
    const pastDate = new Date(dateStr);
    const now = new Date();
    const diffInMs = now - pastDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays;
  },
  // Retorna apenas a hora de uma daterminada data no formato HH:mm
  TIMESTAMP_TO_TIME: (str) => {
    if (!str) return '';
    const date = new Date(str);
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  },
  // Retorna a data e hora de uma data no formato Brasileiro (DD/MM/AAAA HH:mm)
  TIMESTAMP_TO_BR_FULL: (str) => {
    if (!str) return '';
    const date = new Date(str);
    if (isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  },
};

export const normalizeName = (string) => {
  if (!string) {
    return '';
  }
  return string
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};
